import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export default function ImageCropper({ image, onCropDone, onClose }) {
	const [crop, setCrop] = useState({
		unit: "%",
		width: 80,
		aspect: undefined,
	});

	const [completedCrop, setCompletedCrop] = useState(null);
	const [imgRef, setImgRef] = useState(null);

	const onImageLoad = (e) => {
		const img = e.currentTarget;
		setImgRef(img);

		// Start with a large centered crop
		const initialCrop = {
			unit: "%",
			width: 80,
			height: 80,
			x: 10,
			y: 10,
		};

		setCrop(initialCrop);
	};

	const getCroppedImg = () => {
		if (!completedCrop || !imgRef) {
			return;
		}

		const image = imgRef;

		/*
		 * Calculate the scale between the displayed image
		 * and the original/natural image.
		 */
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;

		/*
		 * Convert crop coordinates from displayed pixels
		 * to ORIGINAL image pixels.
		 */
		const cropX = completedCrop.x * scaleX;
		const cropY = completedCrop.y * scaleY;
		const cropWidth = completedCrop.width * scaleX;
		const cropHeight = completedCrop.height * scaleY;

		const canvas = document.createElement("canvas");

		/*
		 * IMPORTANT:
		 * Canvas uses the original image resolution.
		 * This prevents unnecessary resolution loss.
		 */
		canvas.width = Math.round(cropWidth);
		canvas.height = Math.round(cropHeight);

		const ctx = canvas.getContext("2d");

		if (!ctx) {
			return;
		}

		ctx.imageSmoothingEnabled = true;
		ctx.imageSmoothingQuality = "high";

		ctx.drawImage(
			image,
			Math.round(cropX),
			Math.round(cropY),
			Math.round(cropWidth),
			Math.round(cropHeight),
			0,
			0,
			Math.round(cropWidth),
			Math.round(cropHeight)
		);

		/*
		 * JPEG quality = 1.0
		 * This keeps the highest JPEG quality.
		 *
		 * Note:
		 * JPEG itself is still a re-encoding, so it cannot
		 * preserve the exact original JPEG bytes.
		 */
		canvas.toBlob(
			(blob) => {
				if (blob) {
					onCropDone(blob);
					onClose();
				}
			},
			"image/jpeg",
			1.0
		);
	};

	return (
		<div className="crop-container">
			<div className="crop-area">
				<ReactCrop
					crop={crop}
					onChange={(newCrop) => setCrop(newCrop)}
					onComplete={(newCrop) => setCompletedCrop(newCrop)}
					keepSelection
				>
					<img
						src={image}
						alt="Crop"
						onLoad={onImageLoad}
						style={{
							display: "block",
							maxWidth: "100%",
							maxHeight: "70vh",
						}}
					/>
				</ReactCrop>
			</div>

			<div className="crop-controls">
				<button
					type="button"
					className="btn btn-danger"
					onClick={onClose}
				>
					Cancel
				</button>

				<button
					type="button"
					className="btn btn-primary"
					style={{ borderRadius: "4px" }}
					onClick={getCroppedImg}
				>
					Save Crop
				</button>
			</div>
		</div>
	);
};
